import { Avatar } from '@/components/avatar/avatar'
import { Box } from '@/components/Box/Box'

import { Text } from '@/components/Text/Text'

import css from './testimonial-box.module.css'

type CommonProps = {
    children: React.ReactNode
}

type TestimonialBoxAvatarProps = {
    src: string
    quotee: string
    alt: string
    quoteeTitle?: string
    logo?: never
}

type TestimonialBoxLogoProps = {
    src?: never
    quoteeTitle?: never
    alt?: never
    quotee?: never
    logo: React.ReactNode
}

export type TestimonialBoxProps = CommonProps &
    (TestimonialBoxAvatarProps | TestimonialBoxLogoProps)

export function TestimonialBox({
    children,
    src,
    quoteeTitle,
    alt,
    quotee,
    logo,
}: TestimonialBoxProps) {
    return (
        <Box className={css.testimonialBox}>
            <figure className={css.testimonialInner}>
                <div className={css.media}>
                    {src ? <Avatar src={src} alt={alt} /> : null}
                    {logo ? <div className={css.logo}>{logo}</div> : null}
                </div>
                <Text tag="blockquote" className={css.quote}>
                    {children}
                </Text>
                {quotee ? (
                    <figcaption className={css.quotee}>
                        <Text tag="span" size="minor-base">
                            {quotee}
                        </Text>
                        {quoteeTitle ? (
                            <Text tag="span" size="body-xs" className={css.quoteeTitle}>
                                {quoteeTitle}
                            </Text>
                        ) : null}
                    </figcaption>
                ) : null}
            </figure>
        </Box>
    )
}
